import { createFeatureSelector } from '@ngrx/store';

import { homeFeatureKey } from '../home-feature-key';
import { HomeState } from '../reducers';

export const homeState = createFeatureSelector<HomeState>(homeFeatureKey);
